import styled from "styled-components";
import { styledByTheme } from "../../../../themes/architecture/styled-by-theme";

const FreePlayContainerDefaultBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
    
`;

const FreePlayContainerMrGreenCisBox = styled(FreePlayContainerDefaultBox)`
    background-color: ${({theme}) => theme.colors.brandPrimaryDark};
`;

export const FreePlayContainerBox = styledByTheme(FreePlayContainerDefaultBox).forMrGreenCis(FreePlayContainerMrGreenCisBox).apply();